import React from 'react';
import { Followers, Button } from '../../../../components';

import SectionHeroHeader from '../SectionHero/SectionHeroHeader';

import css from './SectionHeroLoggedOut.css';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';

export default ({ history }) => (
    <section className={css.root}>
        <div className={css.container}>
            <div className={css.column}>
                <SectionHeroHeader
                    rootClassName={css.headerRoot}
                    subHeading="Reitbeteiligung mit HorseDeal"
                    mainHeading="Hier findest Du deine"
                    description="Wir machen die Suche nach einem Pferd oder nach passenden Pferdemenschen für dein Pferd einfacher und transparenter als jemals zuvor."
                />
                <footer className={css.footer}>
                    <Button
                        className={css.subLinkPrimary}
                        type="button"
                        onClick={() =>
                            history.push(
                                createResourceLocatorString('SignupPage', routeConfiguration())
                            )
                        }
                    >
                        Kostenlos registrieren
                    </Button>
                    <Followers rootClassName={css.followers}>
                        <p>
                            Sarah, Julia, David und 30’000 weitere sind bereits Teil unserer
                            Community.
                        </p>
                    </Followers>
                </footer>
            </div>
            <div className={css.column}>
                <img
                    src={
                        'https://horsedeal.imgix.net/static/landingPage/horsedeal-reitbeteiligung.webp'
                    }
                    alt="our-customers"
                />
            </div>
        </div>
    </section>
);
